<template>

  <div class="d-flex flex-column align-items-center">

    <memlist-card style="min-width: 380px; min-height: 128px;" class="bg-white w-50 mt-16 mx-auto">

      <p style="text-align: center; font-weight: bold;">Du kan betala med ditt friskvårdsbidrag!</p>
      <p style="text-align: center;" class="mt-4">Klicka på knappen nedan för att logga in på ditt epassi-konto och slutföra betalningen.</p>

      <form style="text-align: center" v-if="local_order" action='https://services.epassi.se/e_payments/v2' method="post">
        <input type="hidden" name="STAMP" :value="epassi_stamp" />
        <input type="hidden" name="SITE" :value="epassi_site" />
        <input type="hidden" name="AMOUNT" :value="epassi_amount" />
        <!--<input type="hidden" name="FEE" :value="epassi_fee" />-->
        <input type="hidden" v-if="show_vat" name="VAT_VALUE" :value="epassi_vat" /> 
        <input type="hidden" name="REJECT" :value="epassi_reject_url"/>
        <input type="hidden" name="CANCEL" :value="epassi_cancel_url" />
        <input type="hidden" name="RETURN" :value="epassi_return_url" />
        <input type="hidden" name="MAC" :value="epassi_mac_value" />
        <input 
          type="image" 
          src="/assets/images/epassi_button.png" 
          alt="Epassi" 
          style="height: 48px; object-fit: contain;"
          class="mt-4"
        />
      </form>
    </memlist-card>
    
  </div>
</template>

<script>
import axios from 'axios';


import { setKeyValue, getKeyValue } from '@/core/services/simpleStore';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'EpassiPaymentComponent',
  props: ['order'],
  emits: ['updated', 'start_polling'],
  mixins: [ toasts ],
  components: {
    
  },
  computed: {
    show_vat() {
      return this.epassi_vat && this.epassi_vat !== '0.00' && this.epassi_vat !== '0.0' && this.epassi_vat !== '0';
    },

    min_width() {
      return {
        'min-width': is_mobile()  ? '460px' : '640px'
      };
    },

    is_mobile() {
      return is_mobile();
    },

    epassi_stamp() {
      return this.local_order.uuid;
    },

    epassi_site() {
      if (!this.local_order || !this.local_order.company) {
        return '';
      }
      return this.local_order.epassi_site;
      //return this.local_order.company.company_settings.epassi_settings.site; 
    },

    epassi_amount() {
      return this.local_order.amount;
    },

    epassi_fee() {
      return '0.0';
    },

    epassi_vat() {
      return this.local_order.epassi_vat_value || '0.0';
    },

    epassi_reject_url() {
      return this.get_rejected_url();
    },

    epassi_cancel_url() {
      return this.get_cancel_url();
    },

    epassi_return_url() {
      return this.get_return_url();
    },

    epassi_mac_value() {
      if (!this.local_order) {
        return '';
      }

      return this.local_order.epassi_mac_value;
    }
  },
  data() {
    return {
      local_order: null
    };
  },

  mounted() {

    if (this.order) {
      this.local_order = { ...this.order };
    }

  },
  watch: {
    order: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_order = { ...this.order };
      }
    },
  },
  methods: {

    get_rejected_url() {
      return get_domain_url() + `/return-epassi/reject/${this.local_order.token}/${this.local_order.shop_order_id}`;
    },
    get_cancel_url() {
      return get_domain_url() + `/return-epassi/cancel/${this.local_order.token}/${this.local_order.shop_order_id}`;
    },
    get_return_url() {
      return get_domain_url() + `/return-epassi/return/${this.local_order.token}/${this.local_order.shop_order_id}`;
    },

  }
};
</script>
